/**
 * Client-side tenant branding types and platform defaults.
 *
 * These types mirror the API's TenantBranding schema but are defined
 * independently for the client to avoid importing server-side code.
 */

export interface TenantBranding {
  logoUrl?: string | null;
  primaryColor?: string | null;
  accentColor?: string | null;
  fontFamily?: string | null;
}

/**
 * Branding with all fields resolved to non-null strings.
 * Produced by merging TenantBranding with PLATFORM_DEFAULTS.
 */
export interface ResolvedBranding {
  logoUrl: string;
  primaryColor: string;
  accentColor: string;
  fontFamily: string;
}

/**
 * Platform defaults used when a tenant has no custom branding configured.
 * These values are applied immediately on render to prevent flash of
 * unstyled content.
 */
export const PLATFORM_DEFAULTS: ResolvedBranding = {
  logoUrl: "",
  primaryColor: "#6366f1", // Indigo-500
  accentColor: "#8b5cf6", // Violet-500
  fontFamily: "Inter, system-ui, sans-serif",
};

/**
 * CSS custom property names used for branding injection.
 */
export const CSS_PROPERTIES = {
  PRIMARY: "--brand-primary",
  ACCENT: "--brand-accent",
  FONT: "--brand-font",
  LOGO_URL: "--brand-logo-url",
} as const;
